import React from 'react';
import Button from 'components/UI/V2/Button/Button';
import { Input } from 'components/UI/V3/Forms/Input/Input';
import { Switch } from 'components/UI/V2/Forms/Switch/Switch';
import { Textarea } from 'components/UI/V3/Forms/Textarea/Textarea';
import { Membership } from '@spike/membership-model';
import { GenerateWithAIButton } from 'components/Memberships/Add/Steps/Details/GenerateWithAIButton';
import { GenerateWithAIDrawer } from 'components/Memberships/Add/Steps/Details/GenerateWithAIDrawer';
import { createStyles, makeStyles, Theme } from '@material-ui/core';

interface MembershipDetailsStepProps {
    membership: Membership;
    onNext: (name: string, description: string, bookableOnline: boolean) => void;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        submitButton: {
            marginTop: 8,

            [theme.breakpoints.up('md')]: {
                alignSelf: 'flex-start'
            }
        }
    })
);

export const MembershipDetailsStep: React.FC<MembershipDetailsStepProps> = props => {
    const classes = useStyles();

    const [showGenerateWithAI, setShowGenerateWithAI] = React.useState(false);
    const [membershipName, setMembershipName] = React.useState({
        value: props.membership.name,
        error: ''
    });
    const [membershipDescription, setMembershipDescription] = React.useState({
        value: props.membership.description,
        error: ''
    });
    const [bookableOnline, setBookableOnline] = React.useState(props.membership.onlineBooking);

    const isValid = React.useMemo(() => {
        const isNameValid = membershipName.error.length === 0 && membershipName.value.length > 0;

        return isNameValid;
    }, [membershipName]);

    const handleMembershipNameChange = React.useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        setMembershipName({
            value: e.target.value,
            error: e.target.value.length === 0 ? 'Membership name is required' : ''
        });
    }, []);

    const handleMembershipDescriptionChange = React.useCallback((e: React.ChangeEvent<HTMLTextAreaElement>) => {
        let errorMessage = '';

        if (e.target.value.length > 400) {
            errorMessage = 'Membership description must be less than 400 characters';
        }

        if (e.target.value.length === 0) {
            errorMessage = 'Membership description is required';
        }

        setMembershipDescription({
            value: e.target.value,
            error: errorMessage
        });
    }, []);

    const addDescriptionHandler = React.useCallback((description: string) => {
        setShowGenerateWithAI(false);
        setMembershipDescription({
            value: description,
            error: ''
        });
    }, []);

    const nextHandler = React.useCallback(() => {
        props.onNext(membershipName.value, membershipDescription.value, bookableOnline);
    }, [props.onNext, membershipName.value, membershipDescription.value, bookableOnline]);

    return (
        <>
            <Input
                label="Membership Name"
                placeholder="Add Membership Name"
                required={true}
                error={membershipName.error}
                value={membershipName.value}
                onChange={handleMembershipNameChange}
            />

            <Textarea
                maxLength={400}
                label="Write a Short Description"
                error={membershipDescription.error}
                //footerActions={<GenerateWithAIButton onClick={() => setShowGenerateWithAI(true)} />}
                value={membershipDescription.value}
                onChange={handleMembershipDescriptionChange}
            />

            {/* Do not remove this switch, it will be used to toggle the online booking feature 
            <Switch
                label="Online Booking"
                inlineLabel="Bookable online"
                checked={bookableOnline}
                onChange={setBookableOnline}
            />
            */}

            <Button
                label="Next"
                size="large"
                noColorOnDisabled
                disabled={!isValid}
                className={classes.submitButton}
                onClick={nextHandler}
            />
            {/*
            <GenerateWithAIDrawer
                open={showGenerateWithAI}
                onClose={() => setShowGenerateWithAI(false)}
                onAddDescription={addDescriptionHandler}
            />
            */}
        </>
    );
};
